export default "__VITE_ASSET__CPv4bB8g__"